import{max as r,min as t}from"./math.js";function n(n,o,u){return r(n,t(o,u))}function o(r,t,o){var u=n(r,t,o);return u>o?o:u}export{n as within,o as withinMaxClamp};
//# sourceMappingURL=within.js.map
